// Cookie utility functions for managing authentication tokens
import { getCookieDomain } from './cookieDomain';

/**
 * Set a cookie
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration (default: 30)
 * @param {string} path - Cookie path (default: '/')
 * @param {string} domain - Cookie domain (optional, auto-detected if null)
 */
export const setCookie = (name, value, days = 30, path = '/', domain = null) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  
  // Auto-detect domain if not provided
  const cookieDomain = domain !== null ? domain : getCookieDomain();
  
  let cookieString = `${name}=${value};expires=${expires.toUTCString()};path=${path}`;
  
  if (cookieDomain) {
    cookieString += `;domain=${cookieDomain}`;
  }
  
  // Add SameSite and Secure for production
  const isProduction = process.env.NODE_ENV === 'production';
  cookieString += `;SameSite=${isProduction ? 'Lax' : 'Lax'}`;
  if (isProduction) {
    cookieString += ';Secure';
  }
  
  document.cookie = cookieString;
};

/**
 * Get a cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} - Cookie value or null if not found
 */
export const getCookie = (name) => {
  const nameEQ = name + '=';
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length);
    }
  }
  return null;
};

/**
 * Delete a cookie
 * @param {string} name - Cookie name
 * @param {string} path - Cookie path (default: '/')
 * @param {string} domain - Cookie domain (optional, auto-detected if null)
 */
export const deleteCookie = (name, path = '/', domain = null) => {
  // Auto-detect domain if not provided
  const cookieDomain = domain !== null ? domain : getCookieDomain();
  
  let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path}`;
  
  if (cookieDomain) {
    cookieString += `;domain=${cookieDomain}`;
  }
  
  document.cookie = cookieString;
};
